import { MBV2NutritionSummary, RecentOrFavoriteEntree } from '@/models';
import { AnalyticsEvent } from '../models';

export class NutritionLinkClickEvent implements AnalyticsEvent {
    nutritionClickEventType: string;
    name = 'NutritionLinkClickEvent';
    entree: RecentOrFavoriteEntree | undefined;
    nutrition: MBV2NutritionSummary | undefined;

  constructor(public readonly event: string, entree?: RecentOrFavoriteEntree, nutrition?: MBV2NutritionSummary) {
    this.nutritionClickEventType = event;
    this.entree = entree;
    this.nutrition = nutrition;
  }
}